$(function () {
  $('.login__submit-button').on('click', function (ev) {
    ev.preventDefault();
    login('login');
  });

  $('.mfa__submit-button').on('click', function (ev) {
    ev.preventDefault();
    login('mfa');
  });

  $('.login-checkbox__container').on('click', function () {
    $(this).toggleClass('-active');
  });
});

// Login user

function login(type) {
  var email = $('.login__email-input').val().trim();
  var password = $('.login__password-input').val();

  if (!email || !password) {
    if (!email) {
      $('.login__email-input').addClass('error');
    }
    if (!password) {
      $('.login__password-input').addClass('error');
    }
    animateEl($('.login__submit-button'), 'shake');
    return false;
  }

  var remember = $('.login-checkbox__container').hasClass('-active') ? 1 : null;
  var mfa_code = $('.mfa__code-input').val().trim();;

  var resetLoadingForm = function () {
    $('.login__textfield .textfield, .mfa__textfield .textfield').removeAttr('disabled');
    $('.login__submit-button, .mfa__submit-button')
      .removeAttr('disabled')
      .removeClass('loading-bar');
  };

  $.ajax({
    url: '/admin/login',
    method: 'post',
    data: {
      type: type,
      email: email,
      password: password,
      remember: remember,
      mfa_code: mfa_code,
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      $('.login__error').html('&nbsp;');
      $('.mfa__code-input').html('&nbsp;').removeClass('active');
      $('.login__textfield .textfield, .mfa__textfield .textfield').attr('disabled', 'disabled');
      $('.login__submit-button, .mfa__submit-button')
        .attr('disabled', 'disabled')
        .addClass('loading-bar');
    },
    success: function (response) {
      if (response.status == 'login-successfull') {
        let redirectUrl = '/admin';

        if (window.location.search && window.location.search.indexOf('?preview-redirect=') === 0) {
          redirectUrl = window.location.search.replace('?preview-redirect=', '') + '?preview';
        }

        window.location.href = redirectUrl;
        return;
      }

      resetLoadingForm();

      if (response.status == 'device-not-trusted') {
        openMfaBox();
        return;
      }

      if (response.status == 'mfa-error') {
        $('.mfa__error').html(
          response && response.error ? response.error : app.error
        ).addClass('active');
        animateEl($('.mfa__submit-button'), 'shake');
        return;
      }

      if (response.status == 'login-error') {
        closeMfaBox();
        $('.login__error').html(
          response && response.error ? response.error : app.error
        );
        animateEl($('.login__submit-button'), 'shake');
        return;
      }

      error();
      animateEl($('.login__submit-button'), 'shake');
    },
    error: function (xhr) {
      resetLoadingForm();
      if (xhr.status == 429) {
        resetMfaBox();
        $('.login__error').html('Zu viele Login-Versuche.<br>Bitte einige Minuten warten.');
        animateEl($('.login__submit-button'), 'shake');
        return;
      }
      ajaxError();
    }
  });
}

function openMfaBox() {
  $('body').addClass('mfa-open');
}

function closeMfaBox() {
  resetMfaBox();
  $('body').removeClass('mfa-open');
}

function resetMfaBox() {
  $('.mfa__code-input').val('');
  $('.mfa__error').html('').removeClass('active');
}
